import { render, staticRenderFns } from "./ModalBeneficiario.vue?vue&type=template&id=0be0b0e0"
import script from "./ModalBeneficiario.vue?vue&type=script&lang=js"
export * from "./ModalBeneficiario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0be0b0e0')) {
      api.createRecord('0be0b0e0', component.options)
    } else {
      api.reload('0be0b0e0', component.options)
    }
    module.hot.accept("./ModalBeneficiario.vue?vue&type=template&id=0be0b0e0", function () {
      api.rerender('0be0b0e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/infoBase/modales/ModalBeneficiario.vue"
export default component.exports